import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_ACTIONS from '../Actions/ActionTypes';
import { productsListInitState } from './CoursesInitState';
import { ProductsListResponse } from '../Types/ProductsListResponse';
import { IProduct } from '../../../__core/Interfaces/IProduct';

export const productsListReducer = (
  state: Array<IProduct> = productsListInitState,
  action: IAction<ProductsListResponse>
): Array<IProduct> => {
  switch (action.type) {
    case COURSE_ACTIONS.FETCH_DIRECT_ACCESS_LIST:
      return [...action.payload.data];

    default:
      return state;
  }
};
